<template>
  <div class="progress-box-pkg" ref="progressBox">
    <div class="progress-content" ref="dialogEl" :style="{ left: left + 'px', top: top + 'px' }">
      <div class="top-progress">
        <div class="top-progress-content">
          <span>{{ $t('文件正在解压中，请稍等...') }}</span>
          <span>{{ customProgress }}</span>
        </div>
      </div>
      <el-progress :percentage="progress" :show-text="false" color="#0A64FA" />
    </div>
  </div>
</template>

<script>
import { getWidthOrHeight } from 'js/util/util'

export default {
  props: {
    progressData: Object,
  },
  data() {
    return {
      left: 0,
      top: 20,
      progress: 10,
      isSlow: false, // 是否让进度条慢下来
      timer: null,
    }
  },
  computed: {
    progressInfo() {
      return this.progressData
    },
    customProgress() {
      const { progress } = this
      return `${progress}%`
    },
  },
  methods: {
    setPos() {
      const $dialog = this.$refs.dialogEl
      const elemW = getWidthOrHeight($dialog, 'width')
      const winW = window.innerWidth || document.documentElement.clientWidth
      this.left = (winW - elemW) / 2
    },
    startProgress() {
      const vm = this
      if (vm.timer == null) {
        vm.timer = setInterval(vm.loading, 100)
      }
    },
    loading() {
      const vm = this
      if (vm.progress === 99) {
        clearInterval(vm.timer)
        vm.timer = null
        return
      }
      if (vm.progress >= 80) {
        vm.progress += 1
        if (!vm.isSlow) {
          clearInterval(vm.timer)
          vm.timer = setInterval(vm.loading, 1000)
          vm.isSlow = true
        }
      } else {
        vm.progress += 1
      }
    },
  },
  mounted() {
    document.body.appendChild(this.$refs.progressBox)
    this.setPos()
    clearInterval(this.timer)
    this.timer = null
    this.startProgress()
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>

<style lang="less" scoped>
.progress-content {
  position: fixed;
  z-index: 999;
  box-sizing: border-box;
  width: 350px;
  min-height: 20px;
  padding: 20px;
  font-size: 15px;
  font-size: 14px;
  text-align: center;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  .top-progress {
    .top-progress-content {
      margin-bottom: 10px;
      color: #4d5365;
    }
  }
}
</style>
